import React, {createRef, useState} from 'react';
import moment from "moment";
import __ from "lodash";
import axios from "axios";
import { Grid } from "@material-ui/core";

import { FormDialog }from "../../../../controls";
import ScheduledTripLegEditor from "./ScheduledTripLegEditor";
import BuildPrimaryRouteFromLegs from '../../utils/BuildPrimaryRouteFromLegs';
import BuildOnwardRoutesFromLegs from '../../utils/BuildOnwardRoutesFromLegs';
import BuildTruckRoutesFromLegs from '../../utils/BuildTruckRoutesFromLegs';
import Validator from "../../validators/EditScheduledTripPlanningValidator";
import AircraftLookup from '../../../Aircraft/components/AircraftLookup';

const EditScheduledTripPlanningDialog = (SystemData, apiSitePrefix, extraKeys, handleUpdate, classes) => {
  const eventBus = SystemData.eventBus;

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    record: {},
    parentRecord: null,
    childRecords: null
  });

  const open = (_record, parentRecord, childRecords, title) => {
    const record = __.cloneDeep(_record);
    setDialogStates({...dialogStates, showDialog:true, record, parentRecord, childRecords, title});
  }
  const close = () => {
    setDialogStates({...dialogStates, showDialog:false, record: {}, parentRecord:null, childRecords:null, title: 'Edit Scheduled Trip'});
  }

  const handleAddSector = () => {
    if (eventBus) {
      eventBus.trigger('ScheduledTrip.AddSector');
    }
  }

  const handleLegsChanged = (changes, props) => {
    const {record, recordChange} = props;
    if (changes && changes.record) {
      const legs = changes.record.legs;
      record['legs'] = legs;
      recordChange({...record, legs});

      if (changes.resolve) {
        changes.resolve();
      }
    }
  }

  const Dialog = (props) => { 
    if (dialogStates.showDialog) {
      return (
        <FormDialog
          title="Edit Scheduled Trip"
          message=""
          open={dialogStates.showDialog}
          record={dialogStates.record}
          dialogOptions={{maxWidth: "lg", fullWidth: true}}
          classes={classes}
          validator={Validator}
          buttons = {{
            addSector: {icon: "add_circle", key: "Add Sector", label: "Add Sector", color: "primary"},
            save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}}, 
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }}
          onChange={(state) => {
            if (state.buttonPressed === "save") {              
              const record = state.record;
              handleUpdate({
                extraKeys,
                record, 
                postSuccess: () => {
                  setDialogStates({...dialogStates, showDialog: false, record: null})
                  if (typeof props.onClose === 'function') {props.onClose()}
                },
                postError: (data) => {
                  if (data.errorMessage) {
                    SystemData.alert("Error", `${data.errorMessage}`);
                  } else {
                    SystemData.alert("Error", `An Unexpected Error has occurred.`);
                  }
                }
              });
            } else if (state.buttonPressed === "addSector") {
              handleAddSector();
            } else {
              setDialogStates({...dialogStates, showDialog: false, record: null});
              if (typeof props.onClose === 'function') {props.onClose()}
            }
          }}

        >
          <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={2} checkChildren={true}>
              <div className="d-flex flex-row justify-content-between align-items-center">
                <label htmlFor="scheduledDate" className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-animated MuiInputLabel-shrink">
                  Trip Date
                </label>
              </div>
              <div id="scheduledDate" style={{paddingTop: 6}}>
                {(rowData) => (<>{moment(rowData.scheduledDate).format('D MMM YYYY')}</>)}              
              </div>
            </Grid>
            <Grid item xs={2} checkChildren={true}>
              <div className="d-flex flex-row justify-content-between align-items-center">
                <label htmlFor="tripNo" className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-animated MuiInputLabel-shrink">
                  Trip Number
                </label>
              </div>
              <div id="tripNo" style={{paddingTop: 6}}>
                {(rowData) => (<>{`${rowData.tripPrefix}${rowData.tripNo}`}</>)}              
              </div>
            </Grid>
            <Grid item xs={2} checkChildren={true}>
              <div className="d-flex flex-row justify-content-between align-items-center">
                <label htmlFor="aircraftReg" className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-animated MuiInputLabel-shrink">
                  Aircraft
                </label>
              </div>
              <div id="aircraftReg" style={{paddingTop: 6}}>
                <AircraftLookup
                  id="aircraftReg"
                />
              </div>
            </Grid>
            <Grid item xs={6} checkChildren={true}>
              <></>
            </Grid>
            <Grid item xs={4} checkChildren={true}>
              <div className="d-flex flex-row justify-content-between align-items-center">
                <label htmlFor="primaryRoute" className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-animated MuiInputLabel-shrink">
                  Route
                </label>
              </div>
              <div id="primaryRoute" style={{paddingTop: 6}}>
                {(rowData) => (<BuildPrimaryRouteFromLegs legs={rowData.legs}/>)}
              </div>
            </Grid>
            <Grid item xs={4} checkChildren={true}>
              <div className="d-flex flex-row justify-content-between align-items-center">
                <label htmlFor="onwardRoutes" className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-animated MuiInputLabel-shrink">
                  Onward Routes
                </label>
              </div>
              <div id="onwardRoutes" style={{paddingTop: 6}}>
                {(rowData) => (<BuildOnwardRoutesFromLegs legs={rowData.legs}/>)}              
              </div>
            </Grid>
            <Grid item xs={4} checkChildren={true}>
            <div className="d-flex flex-row justify-content-between align-items-center">
                <label htmlFor="truckRoutes" className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-animated MuiInputLabel-shrink">
                  Trucking
                </label>
              </div>
              <div id="truckRoutes" style={{paddingTop: 6}}>
                {(rowData) => (<BuildTruckRoutesFromLegs legs={rowData.legs}/>)}              
              </div>
            </Grid>
            <Grid item xs={12} checkChildren={true}>
              <ScheduledTripLegEditor 
                tripRecord={dialogStates.record}
                handleUpdate={handleUpdate}
                extraKeys={extraKeys}
                canEdit={true}
                classes={classes}
                onChange={handleLegsChanged}
              />
            </Grid>
          </Grid>
        </FormDialog>
      )
    }
    return (<></>);
  }
  return {
    Dialog,
    open,
    close
  }
  
}

export default EditScheduledTripPlanningDialog;